import React, { useEffect, useState ,useMemo} from 'react';
import { FormGroup, Label, Form, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import $ from 'jquery';
import moment from 'moment';
import { exportToCSV, exportToExcel, exportToPDF } from '../utils/Exports';
import { useNavigate, useLocation } from 'react-router-dom';
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import Table from './common/Table';
const common = require('../utils/Common');
const envConfig = require('../config/envConfig');

const SellersProducts = () => {
    let navigate = useNavigate();
    const location = useLocation();
    const [allProducts, setAllProducts] = useState([]);
    const [subProducts, setSubProducts] = useState([]);
    const [pincodeModal, setPincodeModal] = useState(false);
    const [pincodes, setPincodes] = useState([]);    
    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);
    const [totalRecords, setTotalRecords] = useState(0);
    const [userRights, setUserRights] = useState({view: false, edit: false, delete: false, create: false});
    const [page, setPage] = useState(1);

	useEffect(() => {
        if (!location.state) {
            navigate('/sellers-products');
            return;
        }
        checkAccess();
	}, []);

    const checkAccess = async () => {
        let rights = await common.checkAccessRights(window.location.pathname);
        if (!rights.view) {
          alert("Access Denied");
          navigate("/");
          return;
        } else {
          setUserRights(rights);
            if (!localStorage.getItem('admin_token')) {
                navigate('/login');
            }
            if (!location.state) {
                navigate('/');
            }
            // setAllProducts(location.state);
            getProducts()
        }
    }

    const showSubProducts = (subProducts) => {
        setSubProducts(subProducts);
        toggle();
    }

    const approveProduct = async (product_id) => {
        let data = {
            'id': product_id,
        }
        let response = await common.apiRequest('post', '/admin/approve-product', data);
        if (response.data.code == 'success') {
            alert(response.data.message);
            getProducts(10, (page - 1) * 10, {}, true, false);

        } else {
            alert(response.data.error);
        }
    }
    const setUnsetHotProduct = async (product_id, value) => {
        let data = {
            'id': product_id,
            'value': value,
            'source': "product"
        }
        let response = await common.apiRequest('post', '/admin/set-unset-hot-product', data);
        if (response.data.code == 'success') {
            alert(response.data.message);
            getProducts(10, (page - 1) * 10, {}, true, false);

        } else {
            alert(response.data.error);
        }
    }
    

    const getProducts = async (limit = 10, offset = 0, search = {}, loader = true, reset = false) => {
      if (reset) {
          setPage(1);
          offset = 0;
      } else {
          setPage(offset / limit + 1);
      }
      const currentStartDate = document.getElementById('Date-from')?.value || location.state.startDate;
      const currentEndDate = document.getElementById('Date-to')?.value || location.state.endDate;
      
        let data = {
            'seller_id': location.state.sellerId,
            'action': "read",
            'start_date': currentStartDate,
            'end_date': currentEndDate,
            'limit': limit,
            'offset': offset
        }
        let response = await common.apiRequest('post', '/admin/get-products', data, loader);
        if (response.data.code == 'success') {
            let filteredProducts = [];
            if (response.data.data && response.data.data.length > 0) {
              filteredProducts = response.data.data.filter(product => {
                return product?.product?.seller_address && product.product.seller_address.delete_address === false;
              });
            }
            setAllProducts(filteredProducts);
            setTotalRecords(response.data.totalRecords);
        } else {
            setAllProducts([]);
        }
    }
    const deleteProdcut = async (product,sellerId) => {
        var parameters = {
            'id': product,
            'seller_id': sellerId,
            'action': 'delete',
        };        
        let response = await common.apiRequest('post', '/admin/get-products', parameters);
        if (response.status == 200) {
            if (response.data.code == "success") {
                alert(response.data.message);
            } else {
                alert(response.data.error, 'error');
            }
            getProducts(10, (page - 1) * 10, {}, true, false);
        }
    }
    const data = allProducts.map((product) => ({
        "Product Name": product.name,
        "Product Description": product.description,
        "Product ID": product.id,
        "Product SKU": product.product_sku,
        "Product Images": product.product_image,
        "Price": product.price, 
        "HSN Code": product.hsn_code,
        "Item Weight": product.item_weight,
        "Item Weight After Pack": product.after_pack_item_weight,
        "After Sale Services": product.after_sale_services,
        "FAQ": product.faq,
        "GST Percent": product.gst_percent,
        "Legal Disclaimer": product.legal_disclaimer,
        "Qty In Stock": product.qty_in_stock,
        "Taxable Value": product.taxable_value,
        "Warranty or Guarantee": product.warranty_or_gurantee,
        "Length": product.length,
        "Breadth": product.breadth,
        "Height": product.height,
        "Cartage": product.cartage,
        "Use or Utility": product.use_or_utility,
        "Self Deliver": product.self_deliver ? "Yes" : "No",
        "Active": product.active ? "Yes" : "No",
        "Delete Item": product.delete_item ? "Yes" : "No",
        "Is Hot": product.is_hot ? "Yes" : "No",
        "Product Variations": product.product_configurations?.map(v => `${v.variation_name}: ${v.variation_value}`).join(', ') || 'No variations',
        "Created At": product.created_at,
        "Updated At": product.updated_at
    }));
    
    
    const handleExportCSV = () => {
        exportToCSV(data, 'products');
    }
    
    const handleExportExcel = () => {
        exportToExcel(data, 'products');
    }

    const handleExportPDF = () => {
        exportToPDF(data, 'products');
    }
    const productColumns = [
  {
    header: "Product Name",
    accessor: "name",
    render: (row) => row.name || row.product?.name || "",
  },

  { header: "Product Date", accessor: "created_at" },
  { header: "Product Description", accessor: "description" },
  { header: "Product ID", accessor: "id" },
  { header: "Product SKU", accessor: "product_sku" },

  {
    header: "Product Media",
    accessor: "product_image",
    render: (row) => {
      const media = row.product_image;
      if (!media) return "";
      
      // Helper function to check if file is video
      const isVideo = (filename) => {
        const videoExtensions = ['.mp4', '.webm', '.mov', '.avi', '.mkv', '.wmv', '.flv', '.m4v'];
        return videoExtensions.some(ext => filename.toLowerCase().includes(ext));
      };
      
      // Helper function to check if file is image
      const isImage = (filename) => {
        const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg', '.webp'];
        return imageExtensions.some(ext => filename.toLowerCase().includes(ext)) || filename.includes('blob');
      };
      
      return (
        <div className="d-flex justify-content-center mb-3 flex-wrap gap-2">
          {media.split(",").map((file, index) => {
            const trimmedFile = file.trim();
            const fullUrl = `${envConfig.api_url}${trimmedFile}`;
            
            if (isVideo(trimmedFile)) {
              return (
                <div key={index} className="media-item">
                  <video
                    width="60"
                    height="60"
                    className="rounded-2"
                    controls
                    preload="metadata"
                    style={{ objectFit: 'cover' }}
                  >
                    <source src={fullUrl} type="video/mp4" />
                    <source src={fullUrl} type="video/webm" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              );
            } else if (isImage(trimmedFile)) {
              return (
                <div key={index} className="media-item">
                  <Zoom zoomImg={false}>
                    <img
                      width="60"
                      height="60"
                      className="rounded-2"
                      src={fullUrl}
                      alt={`Product ${index + 1}`}
                      style={{ objectFit: 'cover' }}
                    />
                  </Zoom>
                </div>
              );
            } else {
              // Fallback for unknown file types
              return (
                <div key={index} className="media-item">
                  <div 
                    className="d-flex align-items-center justify-content-center rounded-2 bg-light"
                    style={{ width: '60px', height: '60px', fontSize: '12px' }}
                  >
                    File
                  </div>
                </div>
              );
            }
          })}
        </div>
      );
    },
  },

  { header: "Price", accessor: "price" },
  { header: "HSN Code", accessor: "hsn_code" },
  { header: "Item Weight", accessor: "item_weight" },
  { header: "Item Weight After Pack", accessor: "after_pack_item_weight" },
  { header: "After Sale Services", accessor: "after_sale_services" },
  { header: "FAQ", accessor: "faq" },
  { header: "GST Percent", accessor: "gst_percent" },
  { header: "Legal Disclaimer", accessor: "legal_disclaimer" },
  { header: "Qty In Stock", accessor: "qty_in_stock" },
  { header: "Taxable Value", accessor: "taxable_value" },
  { header: "Warranty/Guarantee", accessor: "warranty_or_gurantee" },
  { header: "Length", accessor: "length" },
  { header: "Breadth", accessor: "breadth" },
  { header: "Height", accessor: "height" },
  { header: "Cartage", accessor: "cartage" },
  { header: "Use or Utility", accessor: "use_or_utility" },

  {
    header: "Self Deliver",
    accessor: "self_deliver",
    render: (row) => (row.self_deliver ? "Yes" : "No"),
  },

  {
    header: "Active",
    accessor: "active",
    render: (row) => (row.active ? "Yes" : "No"),
  },

  {
    header: "Delete Item",
    accessor: "delete_item",
    render: (row) => (row.delete_item ? "Yes" : "No"),
  },

  {
    header: "Is Hot",
    accessor: "is_hot",
    render: (row) => (row.is_hot ? "Yes" : "No"),
  },

  {
    header: "Product Variations",
    accessor: "product_configurations",
    render: (row) => {
      const variations = row.product_configurations || [];
      if (variations.length === 0) return "No variations";

      return (
        <div style={{ overflowX: "auto" }}>
          <table className="table table-sm table-bordered mb-0">
            <thead>
              <tr>
                <th>Variation</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              {variations.map((variation, index) => (
                <tr key={index}>
                  <td><strong>{variation.variation_name}</strong></td>
                  <td>{variation.variation_value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    },
  },

  {
    header: "Pincodes",
    render: (row) =>
      row.self_deliver ? (
        <button
          className="btn btn-info btn-sm"
          onClick={() => viewPincodes(row.product_id || row.id)}
        >
          View Pincodes
        </button>
      ) : (
        "Not self deliverable"
      ),
  },

  {
    header: "Approve Products Status",
    render: (row) =>
      row.active ? (
        "Approved"
      ) : (
        userRights.edit &&
        <button
          className="btn btn-primary btn-sm"
          onClick={() => approveProduct(row.id)}
        >
          Approve
        </button>
      ),
  },

  {
    header: "Hot Product",
    render: (row) => userRights.edit && <HotProductDropdown data={row} />,
  },

  {
    header: "Delete Products",
    render: (row) => {
      const sellerId = row.product?.seller_id || row.seller_id;
      const productId = row.id;
      return (
        userRights.delete &&
        <button
          className="btn btn-danger btn-sm ml-2"
          onClick={() => deleteProdcut(productId, sellerId)}
        >
          Delete
        </button>
      );
    },
  },
];

    const togglePincodeModal = () => {
        setPincodeModal(!pincodeModal);
    }
    const viewPincodes = async (productId) => {
        let data = {
            'product_id': productId,
            'source': 'admin'
        }
        let response = await common.apiRequest('post', '/seller/get-pincodes', data);
        if (response.data.code === 'success') {
            togglePincodeModal();
            setPincodes(response.data.data);
        } else {
            common.alert(response.data.error, 'error');
        }
    }
    const HotProductDropdown = ({ data }) => {
        const productId = data.id;
        const currentValue = data.is_hot ? "Yes" : "No";
    
        const handleChange = (e) => {
            const value = e.target.value;
            setUnsetHotProduct(productId, value);
        };
    
        return (
            <select
                className="form-select form-select-sm"
                onChange={handleChange}
                value={currentValue}
            >
                <option value="Yes">Yes</option>
                <option value="No">No</option>
            </select>
        );
    };
    
    return (
        <>
        <h1>All Products</h1><br/>
        <Form className='row'>
            <FormGroup className='col-md-4 row'>
                <Label className="col-md-2 col-form-label" for="Date-from">From:</Label>
                <Input type='date' defaultValue={location.state.startDate.length > 0 ? location.state.startDate : moment().startOf('month').format('YYYY-MM-DD')} onChange={() => getProducts()} className="form-control col-md-5" id="Date-from" name="Date-from"></Input>
            </FormGroup>
            <FormGroup className='col-md-4 row'>
                <Label className="col-md-2 col-form-label" for="Date-to">To:</Label>
                <Input type='date' defaultValue={location.state.endDate.length > 0 ? location.state.endDate : moment().endOf('month').format('YYYY-MM-DD')} onChange={() => getProducts()} className="form-control col-md-5" id="Date-to" name="Date-to"></Input>
            </FormGroup>
        </Form>
        <div>
            <button className='btn button-product' onClick={handleExportCSV}>Export to CSV</button>
            <button className='btn button-product' onClick={handleExportExcel}>Export to Excel</button>
            <button className='btn button-product' onClick={handleExportPDF}>Export to PDF</button>
        </div>
        <div className="ag-theme-quartz" style={{ height: 600, width: '100%' }}>
                <Table
                    columns={productColumns}
                    data={allProducts}
                    totalRecords={totalRecords}
                    pageSize={10}
                    currentPage={page}
                    onPageChange = {(limit, offset, search, reset) =>{
                        getProducts(limit, offset, search, true, reset);
                    }}
                />
        </div>
        <Modal isOpen={pincodeModal} toggle={togglePincodeModal} size="md">
            <ModalHeader toggle={togglePincodeModal}>Pincodes List</ModalHeader>
            <ModalBody style={{ maxHeight: '400px', overflowY: 'auto' }}>
                {
                    pincodes.map((pincode) => {
                        return (
                            <>
                                {pincode.pincode}&nbsp;&nbsp;
                            </>
                        );
                    })
                }
            </ModalBody>      
        </Modal>
        </>
    )
}

export default SellersProducts;